import React, { useEffect, useState } from "react";
import { Db } from "./../firebase";
import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  orderBy,
  query,
} from "firebase/firestore";

const PublishPanel = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticles = async () => {
      try {
        const q = query(collection(Db, "posts"), orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setArticles(data);
      } catch (error) {
        console.error("Error loading articles:", error);
      } finally {
        setLoading(false);
      }
    };

    loadArticles();
  }, []);

  const handlePublish = async (id, currentStatus) => {
    const newStatus = currentStatus === "published" ? "draft" : "published";
    const confirmMsg =
      newStatus === "published"
        ? "Publish Article?;"
        : "Hide Article;";

    if (!window.confirm(confirmMsg)) return;

    try {
      await updateDoc(doc(Db, "posts", id), { status: newStatus });
      setArticles((prev) =>
        prev.map((a) =>
          a.id === id ? { ...a, status: newStatus } : a
        )
      );
      alert(
        newStatus === "published"
          ? "✅ Το άρθρο δημοσιεύτηκε με επιτυχία!"
          : "⚠️ Το άρθρο αποδημοσιεύτηκε."
      );
    } catch (error) {
      console.error("Error updating article:", error);
      alert("Σφάλμα κατά την ενημέρωση της κατάστασης.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Σίγουρα θέλεις να διαγράψεις αυτό το άρθρο;")) return;
    try {
      await deleteDoc(doc(Db, "posts", id));
      setArticles((prev) => prev.filter((a) => a.id !== id));
      alert("🗑️ Το άρθρο διαγράφηκε.");
    } catch (error) {
      console.error("Error deleting article:", error);
      alert("Σφάλμα κατά τη διαγραφή.");
    }
  };

  return (
    <div className="container py-4">
      <h3 className="mb-4 text-center text-white">📜 Published & Actions</h3>

      {loading ? (
        <p>Φόρτωση...</p>
      ) : articles.length === 0 ? (
        <p>Δεν υπάρχουν άρθρα ακόμη.</p>
      ) : (
        <table className="table table-dark table-striped align-middle">
          <thead>
            <tr>
              <th>Title</th>
              <th>Category</th>
              <th>Status </th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((a) => (
              <tr key={a.id}>
                <td>{a.title || "—"}</td>
                <td>{a.category || "—"}</td>
                <td>
                  <span
                    className={`badge ${
                      a.status === "published" ? "bg-success" : "bg-secondary"
                    }`}
                  >
                    {a.status === "published" ? "Δημοσιευμένο" : "Πρόχειρο"}
                  </span>
                </td>
                <td>
                  {a.createdAt?.toDate
                    ? a.createdAt.toDate().toLocaleDateString("el-GR")
                    : "—"}
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-warning me-2"
                    onClick={() => handlePublish(a.id, a.status)}
                  >
                    {a.status === "published" ? "⛔ Hide" : "✅ Publish"}
                  </button>

                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(a.id)}
                  >
                    🗑️ Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PublishPanel;
